function copyDictTrackerToProps(object, dictTracker) {
    dictTracker.updateIfNeeded(({ props }) => {
        for (const { key, newExists, newValue } of props.iterateModified()) {
            if (newExists) {
                object[key] = newValue;
            } else {
                delete object[key];
            }
        }
    });
}

export default copyDictTrackerToProps;
